const barCodeTypes: { tag: string; value: string }[] = [
  { tag: 'N/A', value: '0' },
  { tag: 'AZTEC', value: '4096' },
  { tag: 'CALENDAR_EVENT', value: '11' },
  { tag: 'CODABAR', value: '8' },
  { tag: 'CODE_128', value: '1' },
  { tag: 'CODE_39', value: '2' },
  { tag: 'CODE_93', value: '4' },
  { tag: 'DATA_MATRIX', value: '16' },
  { tag: 'EAN_13', value: '32' },
  { tag: 'EAN_8', value: '64' },
  { tag: 'GEO', value: '10' },
  { tag: 'ISBN', value: '3' },
  { tag: 'ITF', value: '128' },
  { tag: 'PDF417', value: '2048' },
  { tag: 'PRODUCT', value: '5' },
  { tag: 'QR_CODE', value: '256' },
  { tag: 'TEXT', value: '7' },
  { tag: 'UPC_A', value: '512' },
  { tag: 'UPC_E', value: '1024' },
  { tag: 'URL', value: '8' },
];

export { barCodeTypes };
